import React, { useState, useEffect, useCallback } from 'react'
import './Home.css';
import AuthorList from '../AuthorList/AuthorList';

const sampleFilings = [
  {
    company: "FIGMA, INC.",
    date: "July 28, 2025",
    cik: "0001579878",
    ticker: "FIG",
    industry: "Services-Prepackaged Software",
    sic: "7372",
    figures: 46
  },
  {
    company: "GOOGLE INC.",
    date: "November 23, 2004",
    cik: "0001288776",
    ticker: "GOOG",
    industry: "Services-Computer Programming, D...",
    sic: "7370",
    figures: 0
  },
  {
    company: "Tesla, Inc.",
    date: "June 2, 2011",
    cik: "0001318605",
    ticker: "TSLA",
    industry: "Motor Vehicles & Passenger Car Bodies",
    sic: "3711",
    figures: 1
  },
  {
    company: "Meta Platforms, Inc.",
    date: "May 16, 2012",
    cik: "0001326801",
    ticker: "META",
    industry: "Services-Computer Programming, D...",
    sic: "7370",
    figures: 25
  },
  {
    company: "Airbnb, Inc.",
    date: "December 7, 2020",
    cik: "0001559720",
    ticker: "ABNB",
    industry: "Services-To Dwellings & Other Buildings",
    sic: "7340",
    figures: 72
  }
];

const tickerCompanies = [
  { name: "Google", year: 2004 }, { name: "Tesla", year: 2010 },
  { name: "Meta", year: 2012 }, { name: "NVIDIA", year: 1999 }, { name: "Netflix", year: 2002 },
  { name: "Airbnb", year: 2020 }, { name: "Uber", year: 2019 }, { name: "Snowflake", year: 2020 },
  { name: "Coinbase", year: 2021 }, { name: "Arm", year: 2023 }, { name: "Reddit", year: 2024 },
  { name: "Rivian", year: 2021 }, { name: "Palantir", year: 2020 }, { name: "Zoom", year: 2019 },
  { name: "Figma", year: 2025 }, { name: "Databricks", year: 2024 }, { name: "Stripe", year: 2024 },
  { name: "SpaceX", year: 2024 }, { name: "OpenAI", year: 2024 }, { name: "Anthropic", year: 2024 }
];

function Home() {
  const [activeFiling, setActiveFiling] = useState(0);
  const [isFlipping, setIsFlipping] = useState(false);

  const nextFiling = useCallback(() => {
    if (isFlipping) return;
    setIsFlipping(true);
    
    // Slide out faster (0.5s total animation, update state at 0.4s)
    setTimeout(() => {
      setActiveFiling((prev) => (prev + 1) % sampleFilings.length);
      setIsFlipping(false);
    }, 500); 
  }, [isFlipping]);

  useEffect(() => {
    const timer = setInterval(() => {
      nextFiling();
    }, 4000); // Flip every 4 seconds
    return () => clearInterval(timer);
  }, [nextFiling]);

  return (
    <>
      <section className="hero">
        <div className="hero-body">
          <div className="container is-max-desktop">
            <div className="columns is-vcentered">
              <div className="column is-7 has-text-left-desktop has-text-centered-mobile">
                <h1 className="title is-1" style={{ 
                  fontFamily: "'Castoro', serif", 
                  fontWeight: 700, 
                  fontSize: '3.5rem', 
                  letterSpacing: '-1px', 
                  color: '#002147',
                  marginBottom: '0.5rem'
                }}>
                  IPO-Mine
                </h1>
                <p className="subtitle is-4 mt-2 has-text-grey-dark">
                  A Toolkit and Dataset for Multimodal IPO Filing Analysis
                </p>
                
                <AuthorList />

                <div className="publication-authors mt-4">
                  <span className="author-block"><sup>1</sup>Georgia Institute of Technology,</span>
                  <span className="author-block"><sup>2</sup>Sai University,</span>
                  <span className="author-block"><sup>3</sup>Duke University</span>
                </div>

                <div className="mt-4">
                  <div className="publication-links">
                    <span className="link-block mr-3">
                      <a href="#" className="external-link button is-normal is-rounded is-dark">
                        <span className="icon">
                          <i className="fas fa-file-pdf"></i>
                        </span>
                        <span>Paper</span>
                      </a>
                    </span>
                    <span className="link-block mr-3">
                      <a href="#" className="external-link button is-normal is-rounded is-dark">
                        <span className="icon">
                          <i className="ai ai-arxiv"></i>
                        </span>
                        <span>arXiv</span>
                      </a>
                    </span>
                    <span className="link-block mr-3">
                      <a href="https://github.com/siddhxrth/IPO-Mine" className="external-link button is-normal is-rounded is-dark">
                        <span className="icon">
                          <i className="fab fa-github"></i>
                        </span>
                        <span>Code</span>
                      </a>
                    </span>
                    <span className="link-block mr-3">
                      <a href="https://huggingface.co/datasets/gtfintechlab/ipo-images" className="external-link button is-normal is-rounded is-dark">
                        <span className="icon">
                          <img src="https://huggingface.co/front/assets/huggingface_logo-noborder.svg" alt="Hugging Face" style={{ width: '18px' }} />
                        </span>
                        <span>Hugging Face</span>
                      </a>
                    </span>
                  </div>
                  
                  <div className="mt-3 cta-section">
                    <a href="https://www.ipomine-demo.siddharthlohani.dev/"
                      className="button is-rounded explore-btn"
                      style={{
                        backgroundColor: '#002147',
                        color: '#fff',
                        fontWeight: 700,
                        padding: '0.7rem 1.8rem',
                        fontSize: '1.05rem',
                        border: 'none',
                        height: 'auto',
                        borderRadius: '50px'
                      }}>
                      <span className="icon">
                        <i className="fas fa-rocket"></i>
                      </span>
                      <span>Launch Data Explorer</span>
                    </a>
                  </div>
                </div>
              </div>

              <div className="column is-5 is-hidden-mobile">
                <div className={`filing-stack ${isFlipping ? 'is-flipping' : ''}`}>
                  {sampleFilings.map((filing, idx) => {
                    let pos = (idx - activeFiling + sampleFilings.length) % sampleFilings.length;
                    const isExiting = isFlipping && idx === activeFiling;
                    
                    if (pos > 2 && !isExiting) return null;

                    return (
                      <div 
                        key={idx} 
                        className={`filing-preview-card ${isExiting ? 'exiting' : `pos-${pos}`}`}
                      >
                        <div className="filing-card-content">
                          <div className="filing-card-tag-internal">Sample Snapshot</div>
                          <div className="sec-header">FORM S-1</div>
                          <div className="sec-company">{filing.company}</div>
                          <div className="sec-date">{filing.date}</div>
                          <div className="sec-divider"></div>
                          <div className="sec-metadata">
                            <div className="metadata-row">
                              <span>CIK</span>
                              <strong>{filing.cik}</strong>
                            </div>
                            <div className="metadata-row">
                              <span>Ticker</span>
                              <strong>{filing.ticker}</strong>
                            </div>
                            <div className="metadata-row">
                              <span>Industry</span>
                              <strong>{filing.industry}</strong>
                            </div>
                            <div className="metadata-row">
                              <span>SIC</span>
                              <strong>{filing.sic}</strong>
                            </div>
                          </div>
                          <div className="sec-footer mt-4">
                            <span className="tag is-info is-light">{filing.figures} Figures Extracted</span>
                            <span className="tag is-success is-light ml-2">Parsed Sections</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="academic-metric-divider">
        <div className="container is-max-desktop">
          <div className="columns is-vcentered has-text-centered">
            <div className="column">
              <span className="divider-number">30+</span>
              <span className="divider-label">Years of Data</span>
            </div>
            <div className="divider-dot"></div>
            <div className="column">
              <span className="divider-number">20,000+</span>
              <span className="divider-label">IPO Filings</span>
            </div>
            <div className="divider-dot"></div>
            <div className="column">
              <span className="divider-number">70,000+</span>
              <span className="divider-label">Extracted Figures</span>
            </div>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="container is-max-desktop">
          <div className="columns is-centered">
            <div className="column is-four-fifths">
              <h2 className="title is-3 section-header">Abstract</h2>
              <div className="content academic-text">
                <p>
                  An Initial Public Offering (IPO) is the process by which a private
                  company becomes publicly traded to raise capital from public investors,
                  requiring the company to submit a detailed regulatory filing
                  describing its business, finances, and risks. These filings are long,
                  inconsistently formatted documents composed of heterogeneous
                  sections that differ in tone, purpose, and structure and integrate
                  narrative text, tables, and figures. Analyzing IPO filings with large
                  language models is challenging and costly, as filings average well
                  over 500,000 tokens and lack reliable structural boundaries.
                </p>
                <p>
                  We introduce the <strong>IPO-Mine Toolkit</strong>, an open-source framework for downloading
                  and parsing IPO filings into standardized, section-structured
                  representations. Our toolkit segments filings, extracts embedded figures,
                  and produces structured outputs that enable large-scale, reproducible
                  analysis workflows over long, multimodal documents.
                </p>
                <p>
                  Using our toolkit, we construct the <strong>IPO-Mine Dataset</strong>, a large, section-structured,
                  multimodal dataset covering IPO filings from 1994 to 2026. We use this
                  dataset to analyze textual sections and extracted figures, benchmark
                  multimodal models on structured image quality assessments, and study
                  how visual and textual disclosure practices vary across industries and
                  over time.
                </p>
              </div>

              <hr className="academic-divider" />

              <h2 className="title is-3 section-header">Research Contributions</h2>
              <div className="content academic-text">
                <p>
                  IPO-Mine addresses the critical need for structured, multimodal data in financial research. 
                  Our work provides three primary contributions to the community:
                </p>
                <div className="contribution-grid mt-5">
                  <div className="contribution-item">
                    <div className="contribution-number">01</div>
                    <div className="contribution-content">
                      <strong>Longitudinal Scale</strong>
                      <p>The first systematic, multimodal dataset covering over three decades of corporate history, enabling long-term studies of disclosure evolution.</p>
                    </div>
                  </div>
                  <div className="contribution-item">
                    <div className="contribution-number">02</div>
                    <div className="contribution-content">
                      <strong>Structural Integrity</strong>
                      <p>Automated, high-fidelity segmentation of heterogeneous IPO filings into standardized, machine-readable sections for large-scale NLP workflows.</p>
                    </div>
                  </div>
                  <div className="contribution-item">
                    <div className="contribution-number">03</div>
                    <div className="contribution-content">
                      <strong>Multimodal Breadth</strong>
                      <p>Extraction and functional categorization of 70,000+ visual elements, providing a benchmark for vision-language models in the financial domain.</p>
                    </div>
                  </div>
                </div>
              </div>

              <hr className="academic-divider" />

              <h2 className="title is-3 section-header">Multimodal Data Diversity</h2>
              <div className="content academic-text">
                <p>
                  The IPO-Mine dataset contains 70,000+ extracted visual elements categorized into diverse functional classes. 
                  Below are representative samples illustrating the breadth of multimodal data captured:
                </p>
                
                <div className="diversity-gallery mt-5">
                  <div className="gallery-item">
                    <img src="/static/images/annotation_examples/image-1770366505730.png" alt="Chart" />
                    <p className="gallery-caption">Fig 1. Financial Chart</p>
                  </div>
                  <div className="gallery-item">
                    <img src="/static/images/annotation_examples/map/image-1770403958923.png" alt="Map" />
                    <p className="gallery-caption">Fig 2. Geographic Map</p>
                  </div>
                  <div className="gallery-item">
                    <img src="/static/images/annotation_examples/infograph/image-1770368095699.png" alt="Infographic" />
                    <p className="gallery-caption">Fig 3. Process Infographic</p>
                  </div>
                  <div className="gallery-item">
                    <img src="/static/images/logo/image-1770369024311.png" alt="Logo" />
                    <p className="gallery-caption">Fig 4. Corporate Logo</p>
                  </div>
                </div>
              </div>

              <hr className="academic-divider" />

              <h2 className="title is-3 section-header">System Overview</h2>
              <div className="content academic-text">
                <p>
                  The IPO-Mine pipeline is designed for robust, large-scale financial document analysis. 
                  By leveraging custom parsing logic and computer vision techniques, we transform 
                  unstructured SEC filings into a machine-readable, multimodal format.
                </p>
                <h3 className="title is-4">The Toolkit</h3>
                <p>
                  The open-source Python toolkit provides a unified interface for researchers to interact 
                  with the SEC EDGAR system. It handles the complexities of document downloading, 
                  HTML-to-text conversion, and precise section segmentation. Key features include:
                </p>
                <ul>
                  <li><strong>Automated Ingestion:</strong> Parallelized downloading of S-1 and S-1/A filings.</li>
                  <li><strong>Structural Parsing:</strong> Identification of Table of Contents and corresponding section boundaries.</li>
                  <li><strong>Multimodal Extraction:</strong> High-resolution extraction of embedded figures, charts, and tables.</li>
                </ul>

                <h3 className="title is-4">The Dataset</h3>
                <p>
                  The resulting IPO-Mine Dataset comprises over 20,000 processed filings, serving as 
                  a longitudinal record of corporate disclosure practices. It includes:
                </p>
                <ul>
                  <li><strong>Long-form Text:</strong> Structured textual data across standardized sections (e.g., Risk Factors, Management Discussion).</li>
                  <li><strong>Visual Elements:</strong> A curated collection of 70,000+ extracted images, categorized for downstream vision-language tasks.</li>
                  <li><strong>Rich Metadata:</strong> Associated company information, industry classifications (SIC), and filing dates for longitudinal studies.</li>
                </ul>
              </div>

              <hr className="academic-divider" />

              <h2 className="title is-3 section-header" id="BibTeX">BibTeX</h2>
              <div className="content">
                <pre className="bibtex-block"><code>{`@article{galarnyk2026ipomine,
  title={IPO-Mine: A Toolkit and Dataset for Multimodal IPO Filing Analysis},
  author={Galarnyk, Michael and Lohani, Siddharth and Kannan, Vidhyakshaya and Nandi, Sagnik and Patel, Aman and Somani, Siddhartha and Hiray, Arnav and Routu, Rutwik and Banerjee, Prasun and Ye, Liqin and Chava, Sudheer},
  journal={arXiv preprint arXiv:26XX.XXXXX},
  year={2026}
}`}</code></pre>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
